const PENDING_STATUSES = new Set([
  "pending",
  "requested",
  "open",
  "awaiting",
  "in_review",
  "in-review",
  "submitted",
]);

function requestTime(row) {
  const t = row?.submittedAt || row?.createdAt || row?.updatedAt;
  const n = t ? new Date(t).getTime() : 0;
  return Number.isFinite(n) ? n : 0;
}

/**
 * Latest / top pending business-change request from a list.
 * Prefers status Pending, then newest by submittedAt/createdAt.
 */
export default function getPendingBusinessChangeRequest(list) {
  const rows = Array.isArray(list) ? list.filter(Boolean) : [];
  if (!rows.length) return null;

  const pending = rows.filter((row) => {
    const status = String(row?.status || "").toLowerCase();
    return PENDING_STATUSES.has(status);
  });

  // Amber / active review only when something is actually pending
  if (!pending.length) return null;

  return [...pending].sort((a, b) => requestTime(b) - requestTime(a))[0] || null;
}
